/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Nav from "./nav"
import Footer from "./footer"
import "./main.css"
require('typeface-nunito');

const Layout = ({ children }) => {

  return (
    <>
      <Nav navItem="test" />
      <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
